import { SelectOption } from '../models/select-option.model';

export abstract class BaseEnumService<T extends string> {
  protected abstract readonly data: Record<string, T>;

  getAll(): Record<string, T> {
    return { ...this.data };
  }

  getKeys(): string[] {
    return Object.keys(this.data);
  }

  getValues(): T[] {
    return Object.values(this.data);
  }

  get(key: string): T {
    return this.data[key];
  }

  getOptions(): SelectOption[] {
    return Object.entries(this.data).map(([value, label]: [string, T]) => ({
      label: label.toString(),
      value,
    }));
  }
}
